/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import BreadCrumb from "Common/BreadCrumb"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"

import * as Yup from "yup"
import { FormikProvider, useFormik } from "formik"
import { toast, ToastContainer } from "react-toastify"
import DropZoneImage from "../../Common/Components/Dropzone"
import { doGetProjectSetting, doPatchProjectSetting } from "../../services/project.service"
import { doFileUpload } from "../../services/file.service"
import { Trash2 } from "lucide-react"

const AboutUsPage = () => {
  const [imageFiles, setImageFiles] = useState<Array<any>>([])
  const [data, setData] = useState<any>();

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      projectSettingId: (data && data.projectSettingId) || '',
      aboutUsEnabled: (data && data.aboutUsEnabled) || false,
      aboutUsContent: (data && data.aboutUsContent) || [],
    },
    validationSchema: Yup.object({
      projectSettingId: Yup.string().optional().nullable(),
      aboutUsEnabled: Yup.boolean().default(false),
      aboutUsContent: Yup.array().of(Yup.object().shape({
        title: Yup.string().optional().nullable(),
        content: Yup.string().optional().nullable(),
      })),
    }),

    onSubmit: async (values) => {
      if (imageFiles.length > 0) {
        for (let index = 0; index < imageFiles.length; index++) {
          const files = imageFiles[index];
          if (files?.length > 0) {
            for (const file of files) {
              const fileObject = await doFileUpload(file.name, file.base64)
              values.aboutUsContent[index].imageUrl = fileObject.s3Url
              values.aboutUsContent[index].imageId = fileObject.fileId
              delete values.aboutUsContent[index].image
            }
          }
        }
      }
      const data = values

      doPatchProjectSetting(data).then((res: any) => {
        toast.success('About Us updated successfully', { autoClose: 2000 })
      }).catch((error) => {
        console.log(error)
      })
    },
  })

  useEffect(() => {
    doGetProjectSetting().then((res: any) => {
      setData(res)
      validation.setValues({
        ...res,
        aboutUsContent: res.aboutUsContent || [{
          title: '',
          image: '',
          content: '',
        }],
      })
    })
  }, [])

  return (
    <React.Fragment>
      <BreadCrumb title={'Setting'} pageTitle='Setting' pageTitleLink="/setting" />
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-12">
          <div className="card scroll">
            <div id="card-body" className="!pb-32 card-body">
              <FormikProvider value={validation}>
                <form action="#!" onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}>
                  <div className="grid grid-cols-3 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="xl:col-span-6">
                      <div className="flex items-center gap-3">
                        <label
                          htmlFor={`allowExternalBookingOption`}
                          className="flex flex-col gap-4 p-5 border rounded-md cursor-pointer md:flex-row border-slate-200 dark:border-zink-500 peer-checked:border-purple-500 dark:peer-checked:border-purple-700">
                          <span className="grow flex items-center gap-3">
                            <input id={`allowExternalBookingOption`}
                              className="w-4 h-4 border appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-purple-500 checked:border-purple-500 dark:checked:bg-purple-500 dark:checked:border-purple-500 checked:disabled:bg-purple-400 checked:disabled:border-purple-400 peer"
                              type="checkbox"
                              name="aboutUsEnabled"
                              checked={validation.values.aboutUsEnabled}
                              onChange={validation.handleChange} />
                            <span className="block font-semibold text-15">Enable</span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  {
                    validation.values.aboutUsContent?.map((item: any, index: number) => (
                      <div key={index} className="grid grid-cols-3 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                        <div className="xl:col-span-6">
                          <div className="items-center gap-3">
                            <DropZoneImage
                              selectfiles={imageFiles[index]}
                              setSelectfiles={(value) => {
                                const newImageFiles = [...imageFiles]
                                newImageFiles[index] = value
                                setImageFiles(newImageFiles)
                              }}
                              formikData={validation}
                              fieldName={`aboutUsContent[${index}].imageUrl`}
                              files={validation.values.aboutUsContent[index].imageUrl}
                              filesType="url"
                              maxFiles={1}
                            />
                          </div>
                        </div>
                        <div className="xl:col-span-6">
                          <div className="flex items-center gap-3">
                            <input
                              id={`aboutUsContent[${index}].title`}
                              type="text"
                              placeholder="Title"
                              name={`aboutUsContent[${index}].title`}
                              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                              value={item.title}
                              onChange={validation.handleChange}
                            />
                            <Trash2 className="w-4 h-4 text-red-500"
                              onClick={() => {
                                const newAboutUsContent = [...validation.values.aboutUsContent]
                                newAboutUsContent.splice(index, 1)
                                validation.setFieldValue(`aboutUsContent`, newAboutUsContent)
                              }}
                            />
                          </div>
                          <div className="flex items-center gap-3 mt-4">
                            <ReactQuill
                              id={`aboutUsContent[${index}].content`}
                              placeholder="Description"
                              className="w-full border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                              theme="snow"
                              value={item.content}
                              onChange={(value) => {
                                validation.setFieldValue(`aboutUsContent[${index}].content`, value)
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ))
                  }
                  <div className="mt-4">
                    <button
                      type="button"
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20 w-full"
                      onClick={() => {
                        validation.setFieldValue(`aboutUsContent`, [...validation.values.aboutUsContent, {
                          title: '',
                          image: '',
                          content: '',
                        }])
                      }}>
                      {'Add New'}
                    </button>
                  </div>
                  <div className="flex justify-end gap-2 mt-4">
                    <button type="submit" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                      {'Save'}
                    </button>
                  </div>
                </form>
              </FormikProvider>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AboutUsPage